import {PageWithLayout, requireSession} from "./Page";
import {useAuth} from "../components/auth/AuthContext";
import {FullPageSpinner} from "../components/loading/Spinner";
import {ReactElement} from "react";
import {CaptchaRetry} from "../components/captcha/CaptchaRetry";
import {Navigate} from "react-router-dom";
import {CentralContent} from "../components/central-content/CentralContent";

export const CaptchaPage = () => {
  return requireAuth(requireSession(
      <PageWithLayout>
        <CentralContent>
          <CaptchaRetry />
        </CentralContent>
      </PageWithLayout>
  ));
};

const requireAuth = (elem: ReactElement | null) => {
  const {user, loading} = useAuth();
  if (loading) {
    return <FullPageSpinner/>;
  }
  if (!user) {
    return <Navigate to="/login"/>
  }
  return elem;
}